// extracted by mini-css-extract-plugin
export var article = "style-module--article--f73ed";
export var content = "style-module--content--00214";
export var navCol = "style-module--navCol--88b86";